import React from "react";
import "./footer.css";
import Flag from 'react-world-flags';
import { Button } from "react-bootstrap";

function Footer() {
    return (
        <>
            <div className="footer">
                <div className="box">
                    <div className="col">
                        <img src={require("../../photo/asco_white_trans.png")} className="logo"></img>
                        <h6 style={{ marginTop: '30px' }}>PT. Asco Jaya Huditama</h6>
                        <Flag code="id" className="flag" />
                    </div>
                    <div className="col">
                        <h4>Address</h4>
                        <h6 className="alamat">Jl. Pegangsaan Dua No.10, RT.5/RW.2, Pegangsaan Dua, Kec. Klp. Gading, Jakarta, Daerah Khusus Ibukota Jakarta, 14250</h6>
                    </div>
                    <div className="col">
                        <div className="contact">
                            <h4>Contact</h4>
                            <h6 className="phone">
                                Whatsapp & Phone
                                <i class="bi bi-whatsapp" style={{ marginLeft: '6px' }}> </i>
                                : <Button href="https://wa.me/+6281290960101" style={{ backgroundColor: 'transparent', borderColor: 'white', marginInline: '10px' }}>Click Here!</Button>
                            </h6>
                            <h6>Email: asco.motor@gmail.com</h6>
                            <h6>Instagram: ascomotortuning</h6>
                        </div>
                    </div>
                </div>
                <div className="box">
                    <div className="row">
                        <p className="col-lg rights">
                            &copy;{new Date().getFullYear()} PT. Asco Jaya Huditama | All rights reserved |
                            Terms Of Service | Privacy
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer;